import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice'
import bowtiesReducer from '../features/bowties/bowtiesSlice'
import bowtieReducer from '../features/bowtie/bowtieSlice'
import threatReducer from '../features/threats/threatsSlice'
import barrierReducer from '../features/barriers/barriersSlice'
import consequenceReducer from '../features/consequences/consequencesSlice'
import passwordReducer from '../features/password/passwordSlice'
import severityReducer from '../features/severities/severitiesSlice'
import likelihoodReducer from '../features/likelihoods/likelihoodsSlice'
import dashboardReducer from '../features/dashboard/dashboardSlice'
import orgReducer from '../features/org/orgSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    org: orgReducer,
    bowties: bowtiesReducer,
    bowtie: bowtieReducer,
    threats: threatReducer,
    barriers: barrierReducer,
    consequences: consequenceReducer,
    password: passwordReducer,
    severity: severityReducer,
    likelihood: likelihoodReducer,
    dashboard: dashboardReducer,
  },
});
